import type { TagProps } from '@/components';
import type { TagBaseModel } from '@/features/tag/models';
import type { FC } from 'react';
import type { z } from 'zod';
import { FeatureTag } from './FeatureTag';
import { TagIcon } from './TagIcon';

type Props = Omit<TagProps, 'bordered'> & {
  tag: Pick<z.infer<typeof TagBaseModel>, 'name' | 'scope'>;
};

export const TagTarget: FC<Props> = ({ tag }) => {
  return (
    <FeatureTag icon={<TagIcon scope={tag.scope} />}>{tag.name}</FeatureTag>
  );
};
